import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import BusService from "./BusService";

const initialState = {
    business: null,
    isBusSuccess: false,
    isBusError: false,
    isBusLodaing: false,
    Busmassage: "",
};

export const getAllBusiness = createAsyncThunk(
    "business/get",
    async (_, thunkAPI) => {
        try {
            const token = thunkAPI.getState().auth.mainUser.data.token;
            return await BusService.getAllBusiness(token);
        } catch (error) {
            const massage = error.message;
            return thunkAPI.rejectWithValue(massage);
        }
    }
);

export const searchBusiness = createAsyncThunk(
    "business/search",
    async (data, thunkAPI) => {
        try {
            const token = thunkAPI.getState().auth.mainUser.data.token;
            return await BusService.searchBusiness(data, token);
        } catch (error) {
            const massage = error.message;
            return thunkAPI.rejectWithValue(massage);
        }
    }
);

export const CreateNewBusiness = createAsyncThunk(
    "business/post",
    async (data, thunkAPI) => {
        try {
            const token = thunkAPI.getState().auth.mainUser.data.token;
            return await BusService.CreateBusiness(data, token);
        } catch (error) {
            const massage = error.message;
            return thunkAPI.rejectWithValue(massage);
        }
    }
);

// Delete Business
export const DeleteBusiness = createAsyncThunk(
    "business/delete",
    async (id, thunkAPI) => {
        try {
            const token = thunkAPI.getState().auth.mainUser.data.token;
            return await BusService.deleteBusiness(id, token);
        } catch (error) {
            const massage = error.response;
            return thunkAPI.rejectWithValue(massage);
        }
    }
);

// Delete Business
export const UpdateBusiness = createAsyncThunk(
    "business/update",
    async (id, thunkAPI) => {
        try {
            const token = thunkAPI.getState().auth.mainUser.data.token;
            return await BusService.updateBusiness(id, token);
        } catch (error) {
            const massage = error.response;
            return thunkAPI.rejectWithValue(massage);
        }
    }
);

const BusSlice = createSlice({
    name: "business",
    initialState,
    reducers: {
        resetBusiness: (state) => {
            state.isBusSuccess = false;
            state.isBusError = false;
            state.isBusLodaing = false;
            state.Busmassage = "";
        },
        busSearchAction: (state, action) => {
            state.search = action.payload;
        },
    },
    extraReducers: {
        [getAllBusiness.pending]: (state) => {
            state.isBusLodaing = true;
        },
        [getAllBusiness.fulfilled]: (state, action) => {
            state.isBusLodaing = false;
            state.business = action.payload;
            state.isBusSuccess = true;
        },
        [getAllBusiness.rejected]: (state, action) => {
            state.isBusLodaing = false;
            state.isBusError = true;
            state.Busmassage = action.payload;
        },
        //////////////////////
        [CreateNewBusiness.pending]: (state) => {
            state.isBusLodaing = true;
        },
        [CreateNewBusiness.fulfilled]: (state, action) => {
            state.isBusLodaing = false;
            state.isBusSuccess = true;
            state.Busmassage = action.payload.messages[0];
        },
        [CreateNewBusiness.rejected]: (state, action) => {
            state.isBusLodaing = false;
            state.isBusError = true;
            state.Busmassage = action.payload;
        },

        //////////////////////
        [searchBusiness.pending]: (state) => {
            state.isBusLodaing = true;
        },
        [searchBusiness.fulfilled]: (state, action) => {
            state.isBusLodaing = false;
            state.business = action.payload;
            state.isBusSuccess = true;
        },
        [searchBusiness.rejected]: (state, action) => {
            state.isBusLodaing = false;
            state.isBusError = true;
            state.Busmassage = action.payload;
        },
        //delete business
        [DeleteBusiness.pending]: (state) => {
            state.isBusLodaing = true;
        },
        [DeleteBusiness.fulfilled]: (state, action) => {
            state.isBusLodaing = false;
            state.Busmassage = action.payload;
            state.isBusSuccess = true;
        },
        [DeleteBusiness.rejected]: (state, action) => {
            state.isBusLodaing = false;
            state.isBusError = true;
            state.Busmassage = action.payload;
        },

        //update business
        [UpdateBusiness.pending]: (state) => {
            state.isBusLodaing = true;
        },
        [UpdateBusiness.fulfilled]: (state, action) => {
            state.isBusLodaing = false;
            state.Busmassage = action.payload.messages[0];
            state.isBusSuccess = true;
        },
        [UpdateBusiness.rejected]: (state, action) => {
            state.isBusLodaing = false;
            state.isBusError = true;
            state.Busmassage = action.payload;
        },
    },
});

export const { resetBusiness, busSearchAction } = BusSlice.actions;
export default BusSlice.reducer;
